import { createPaginatedResource } from '@atlassian/eoc-pagination';

import { getList } from '../../endpoints/list';

const listResource = createPaginatedResource({
	type: 'getListResource',
	getKey: () => 'getListResource',
	getData: () => getList,
	isBrowserOnly: true,
});

export { listResource };
